import { useEffect, useState } from "react"
import { UseReviewableCompletionsReturn } from "./ReviewContextProvider"
import {
  CreatePathCompletionsTreeReturn,
  createPathCompletionsTree
} from "./tree/path-tree"

export type UseCompletionsStoreReturn = ReturnType<typeof useCompletionsStore>

const useCompletionsStore = (context: UseReviewableCompletionsReturn) => {
  // this takes incoming completions items from context and creates a node tree + map
  // it also handles filtering and searching client side
  let [treeData, setTreeData] =
    useState<CreatePathCompletionsTreeReturn | null>(null)
  let [tree, setTree] = useState<
    CreatePathCompletionsTreeReturn["tree"] | null
  >(null)
  let [map, setMap] = useState<CreatePathCompletionsTreeReturn["map"] | null>(
    null
  )

  const [searchTerm, setSearchTerm] = useState<string | null>(null)

  const reset = () => {
    setTreeData(null)
    setTree(null)
    setMap(null)
  }

  // initial load
  useEffect(() => {
    if (context.items && context.items.length > 0) {
      setTreeData(createPathCompletionsTree(context, context.items))
    } else {
      reset()
    }
  }, [context.items])

  useEffect(() => {
    if (treeData) {
      setTree(treeData.tree)
      setMap(treeData.map)
    }
  }, [treeData])

  const search = (term: string | null) => {
    setSearchTerm(term)
  }

  const set = (id: string, data: any) => {
    if (map) {
      const item = map.get(id)
      if (item) {
        const newItem = { ...item, ...data }
        setMap(new Map(map).set(id, newItem))
      }
    }
  }

  const get = (id: string) => {
    if (map) return map.get(id)
    return null
  }

  return {
    map,
    tree,
    actions: {
      search,
      set,
      get
    }
  }
}

export default useCompletionsStore
